import { Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { CSSProperties, MouseEvent, useCallback, useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import LocalizationContext from '../../contexts/LocalizationContext';

interface Language {
    name: string;
    short: string;
}

const languages: Language[] = [
    {
        name: 'English',
        short: 'en',
    },
    {
        name: 'Français',
        short: 'fr',
    },
];

const useStyles = makeStyles({
    language: {
        margin: '9px',
    },
    languageName: {
        lineHeight: '32px',
        display: 'inline-block',
    },
    langIcon: {
        fontWeight: 600,
        minWidth: 'unset',
        textTransform: 'uppercase',
        width: '40px',
    },
});

interface SelectLanguageProps {
    onLanguageChanged(lang: string): void;
    style?: CSSProperties;
    className?: string;
}

const SelectLanguage = ({ style, className, onLanguageChanged }: SelectLanguageProps) => {
    const localization = useContext(LocalizationContext);
    const [cookies, setCookie] = useCookies(['lang']);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<any>(null);

    const setLanguage = useCallback(
        (lang) => {
            setCookie('lang', lang, {
                path: '/',
            });
        },
        [setCookie]
    );

    useEffect(() => {
        if (cookies.lang && cookies.lang !== localization.lang) {
            onLanguageChanged(cookies.lang);
        }
    }, [cookies.lang, localization, onLanguageChanged, setLanguage]);

    return (
        <>
            <Button
                style={style}
                className={`${classes.langIcon} ${className}`}
                onClick={(e: MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget)}>
                <div style={{ textTransform: 'uppercase', fontSize: '17px', paddingBottom: '2px' }}>{localization.lang}</div>
            </Button>
            <Menu open={Boolean(anchorEl)} keepMounted anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                {languages.map((language: Language) => (
                    <MenuItem
                        key={language.short}
                        value={language.short}
                        button
                        onClick={() => {
                            setLanguage(language.short);
                            setAnchorEl(null);
                        }}>
                        <div className={classes.langIcon}>{language.short}</div>
                        <div className={classes.languageName}>{language.name}</div>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default SelectLanguage;
